import React from 'react';
import { Text as SVGText } from '@visx/text';
import { scaleLinear } from '@visx/scale';
import { usePieData } from "../hooks/index.js";
import { getAggTitle } from "./Util.js";
import S from './DonutTextRenderer.css';
export default function DonutTextRenderer({
  data,
  attribute,
  isAgg,
  query,
  sourceObjectType,
  limit,
  includeNull,
  valueRanges,
  outerRadius,
  innerCount,
  innerTitle
}) {
  const {
    fontSize: countFontSize = 50,
    fontFamily: countFontFamily,
    yOffset: countYOffset,
    color: countColor,
    visible: countVisible,
    total: countTotal
  } = innerCount;
  const {
    fontSize: titleFontSize = 25,
    fontFamily: titleFontFamily,
    color: titleColor,
    yOffset: titleYOffset,
    visible: titleVisible,
    text: titleText
  } = innerTitle;
  const count = usePieData(data, {
    isAgg,
    attribute,
    valueRanges,
    limit,
    includeNull,
    donutCount: countTotal ? 'total' : 'count'
  });
  const getTitle = isAgg => {
    if (titleText) return titleText;
    if (isAgg) {
      return getAggTitle(query, sourceObjectType);
    }
    const typeCheck = attribute.type || attribute.valueType;
    let title = `${attribute.label || attribute.name}s`;
    if (!typeCheck.includes('string')) title = `${attribute.label || attribute.name}`;
    if ((attribute.label || attribute.name).endsWith('s')) {
      title = attribute.label || attribute.name;
    }
    if (countTotal) title = 'Total';
    return title;
  };
  const countSize = scaleLinear({
    domain: [0, 180],
    range: [0, countFontSize]
  });
  const titleSize = scaleLinear({
    domain: [0, 180],
    range: [0, titleFontSize]
  });
  const titleDy = scaleLinear({
    domain: [0, 180],
    range: [0, titleYOffset]
  });
  const countDy = scaleLinear({
    domain: [0, 180],
    range: [0, countYOffset]
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, countVisible && /*#__PURE__*/React.createElement(SVGText, {
    textAnchor: "middle",
    fill: countColor,
    fontFamily: countFontFamily,
    fontSize: countSize(outerRadius),
    dy: countDy(outerRadius),
    className: S.count
  }, count), titleVisible && /*#__PURE__*/React.createElement(SVGText, {
    textAnchor: "middle",
    fill: titleColor,
    fontFamily: titleFontFamily,
    fontSize: titleSize(outerRadius),
    dy: titleDy(outerRadius)
  }, getTitle(isAgg)));
}